import { useState } from "react";
import restAPI from "@app/config/apiConfig";

const GravityFormsAPI = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [response, setResponse] = useState("");

	const getGravityFormss = () => {
		setLoading(true);
		setError("");
		setResponse("");

		restAPI
			.get("forms")
			.then(({ data }) => {
				setResponse(data.forms);
			})
			.catch(() => {
				setError("Failed to call API, maybe you are disconnected!");
			})
			.finally(() => {
				setLoading(false);
			});
	};

	return {
		loading,
		error,
		response,
		getGravityFormss,
	};
};

export default GravityFormsAPI;
